export const GET_BASIC_COMPANY = gql`
  query BasicCompany($id: String!) {
    basicCompany(id: $id) {
      companyId
      companyName
    }
  }
`

export const GET_PUBLIC_COMPANY = gql`
  query PublicCompany($companyId: String!) {
    publicCompany(companyId: $companyId) {
      companyId
      companyName
      companyPhoneNumber
      jobListings {
        jobListingId
        title
        type
        trackingLinks {
          trackingLinkId
          linkStatus
          linkType
          linkName
          link
        }
      }
    }
  }
`

export const GET_COMPANY = gql`
  query Company($id: String!) {
    company(id: $id) {
      companyId
      companyName
      dotNumber
      einNumber
      companySlug
      phoneNumber
      companyPhoneNumber
      companyFaxNumber
      address {
        addressId
        street
        city
        state
        country
        zipCode
      }
      useRecruiterLine
      callRecordingsEnabled
      transcriptionEnabled
      recruiterLeadEmailNotifyEnabled
      sendIncomingTextNotification
      atsEnabled
      preAdverseActionDelayHours
      finalAdverseActionDelayHours
      voeVerificationPeriodMonths
      autoCancelOutOfWindowVoEs
      atsEmailTrackingEnabled
      atsInboundEmailAddress
      expirationTrackingEnabled
      documentIntelligenceEnabled
      incomingVoEAssignedEmployees {
        employeeId
        firstName
        lastName
        email
        status
      }
      outgoingVoEAssignedEmployees {
        employeeId
        firstName
        lastName
        email
        status
      }
    }
  }
`

export const GET_ADMIN_COMPANY = gql`
  query AdminCompany($id: String!) {
    adminCompany(id: $id) {
      companyId
      companyName
      companyHireRightName
      dotNumber
      einNumber
      phoneNumber
      companyPhoneNumber
      companyFaxNumber
      hireRightCompanyLogin
      hireRightSubAccountCompanyLogin
      asurintUsername
      asurintPassword
      asurintAccountId
      asurintLocationId
      driverIQAccountCode
      driverIQTenant
      driverIQClientId
      driverIQClientSecret
      preAdverseActionDelayHours
      finalAdverseActionDelayHours
      voeVerificationPeriodMonths
      address {
        addressId
        street
        city
        state
        country
        zipCode
      }
      useRecruiterLine
      callRecordingsEnabled
      transcriptionEnabled
      voiceAgentEnabled
      atsEnabled
      recruiterLeadEmailNotifyEnabled
      sendIncomingTextNotification
      trainingEnabled
      trainixCompanyId
      lumaUsername
      lumaPasswordSet
      atsEmailTrackingEnabled
      atsInboundEmailAddress
      documentIntelligenceEnabled
      incomingVoEAssignedEmployees {
        employeeId
        firstName
        lastName
        email
        status
      }
      outgoingVoEAssignedEmployees {
        employeeId
        firstName
        lastName
        email
        status
      }
    }
  }
`

export const CREATE_COMPANY = gql`
  mutation CreateCompany($input: CreateCompanyInput!) {
    createCompany(input: $input) {
      companyId
      companyName
      dotNumber
      einNumber
      companyPhoneNumber
      companyFaxNumber
      address {
        addressId
        street
        city
        state
        country
        zipCode
      }
      useRecruiterLine
      callRecordingsEnabled
      transcriptionEnabled
      voiceAgentEnabled
      atsEnabled
      recruiterLeadEmailNotifyEnabled
      trainingEnabled
      trainixCompanyId
      hireRightCompanyLogin
      hireRightSubAccountCompanyLogin
      companyHireRightName
      asurintUsername
      asurintPassword
      asurintAccountId
      asurintLocationId
      driverIQAccountCode
      driverIQTenant
      driverIQClientId
      driverIQClientSecret
    }
  }
`

export const UPDATE_COMPANY = gql`
  mutation UpdateCompany($id: String!, $input: UpdateCompanyInput!) {
    updateCompany(id: $id, input: $input) {
      companyId
      companyName
      dotNumber
      einNumber
      companySlug
      companyPhoneNumber
      companyFaxNumber
      address {
        addressId
        street
        city
        state
        country
        zipCode
      }
      useRecruiterLine
      callRecordingsEnabled
      transcriptionEnabled
      recruiterLeadEmailNotifyEnabled
      sendIncomingTextNotification
      atsEnabled
      preAdverseActionDelayHours
      finalAdverseActionDelayHours
      voeVerificationPeriodMonths
      autoCancelOutOfWindowVoEs
      atsEmailTrackingEnabled
      atsInboundEmailAddress
      documentIntelligenceEnabled
    }
  }
`

export const UPDATE_ADMIN_COMPANY = gql`
  mutation UpdateAdminCompany($id: String!, $input: UpdateAdminCompanyInput!) {
    updateAdminCompany(id: $id, input: $input) {
      companyId
      companyName
      companyHireRightName
      dotNumber
      einNumber
      phoneNumber
      companyPhoneNumber
      companyFaxNumber
      address {
        addressId
        street
        city
        state
        country
        zipCode
      }
      hireRightCompanyLogin
      hireRightSubAccountCompanyLogin
      asurintUsername
      asurintPassword
      asurintAccountId
      asurintLocationId
      driverIQAccountCode
      driverIQTenant
      driverIQClientId
      driverIQClientSecret
      useRecruiterLine
      callRecordingsEnabled
      transcriptionEnabled
      voiceAgentEnabled
      atsEnabled
      recruiterLeadEmailNotifyEnabled
      sendIncomingTextNotification
      trainingEnabled
      trainixCompanyId
      preAdverseActionDelayHours
      finalAdverseActionDelayHours
      voeVerificationPeriodMonths
      atsEmailTrackingEnabled
      atsInboundEmailAddress
      documentIntelligenceEnabled
    }
  }
`

export const ASSIGN_INCOMING_VOE_EMPLOYEES = gql`
  mutation AssignIncomingVoEEmployees(
    $companyId: String!
    $employeeIds: [String!]!
  ) {
    assignIncomingVoEEmployees(
      companyId: $companyId
      employeeIds: $employeeIds
    ) {
      companyId
      incomingVoEAssignedEmployees {
        employeeId
        firstName
        lastName
        email
        status
      }
    }
  }
`

export const ASSIGN_OUTGOING_VOE_EMPLOYEES = gql`
  mutation AssignOutgoingVoEEmployees(
    $companyId: String!
    $employeeIds: [String!]!
  ) {
    assignOutgoingVoEEmployees(
      companyId: $companyId
      employeeIds: $employeeIds
    ) {
      companyId
      outgoingVoEAssignedEmployees {
        employeeId
        firstName
        lastName
        email
        status
      }
    }
  }
`

export const CONFIGURE_COMPANY = gql`
  mutation ConfigureCompany($input: CreateCompanyInput!) {
    configureCompany(input: $input) {
      companyId
      companyName
      dotNumber
      einNumber
      companyPhoneNumber
      companyFaxNumber
      address {
        addressId
        street
        city
        state
        country
        zipCode
      }
      useRecruiterLine
      callRecordingsEnabled
      transcriptionEnabled
      voiceAgentEnabled
      atsEnabled
      recruiterLeadEmailNotifyEnabled
      trainingEnabled
      trainixCompanyId
      hireRightCompanyLogin
      hireRightSubAccountCompanyLogin
      companyHireRightName
      asurintUsername
      asurintPassword
      asurintAccountId
      asurintLocationId
      driverIQAccountCode
      driverIQTenant
      driverIQClientId
      driverIQClientSecret
    }
  }
`

export const CREATE_COMPANY_LOGO_UPLOAD_URL = gql`
  mutation CreateCompanyLogoUploadUrl(
    $companyId: String!
    $contentType: String!
  ) {
    createCompanyLogoUploadUrl(companyId: $companyId, contentType: $contentType) {
      uploadUrl
      logoUrl
    }
  }
`

// Separate mutation for luma credential updates. Password is never sent to frontend.
// we only send new values when changed, and the backend never returns the password (only lumaPasswordSet).
// This pattern aligns with the future Vault swap for encrypted credential storage.
export const UPDATE_LUMA_CREDENTIALS = gql`
  mutation UpdateLumaCredentials($id: String!, $input: UpdateLumaCredentialsInput!) {
    updateLumaCredentials(id: $id, input: $input) {
      companyId
      lumaUsername
      lumaPasswordSet
    }
  }
`
